import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["limit"];
import { getOperationName } from '../../../../common/utils/operation';
import { ACTIVITY_FILTER_COLLECTION } from '../../activity-filters';
var ACTIVITIES_LIMIT = 50;
var WORKED_ON_QUERY = "\n   workedOn(first: $first, filter: $filter) {\n     ...activityItemConnection\n   }\n";
var VIEWED__QUERY = "\n   viewed(first: $first, filter: $filter) {\n     ...activityItemConnection\n   }\n";
var ALL__QUERY = "\n    all(first: $first, filter: $filter) {\n      ...activityItemConnection\n    }\n";
var activityQueryMap = new Map([['workedOn', WORKED_ON_QUERY], ['viewed', VIEWED__QUERY], ['all', ALL__QUERY]]);
var getMyActivitiesQuery = function getMyActivitiesQuery(queries) {
  return "\n      myActivity {\n        ".concat(queries.join('\n'), "\n      }\n");
};
var getActivitiesQuery = function getActivitiesQuery(product, content, fragments) {
  var activityFilterType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'ActivityFilter';
  return "\n    query ".concat(getOperationName(product), "($first: Int, $filter: ").concat(activityFilterType, ") {\n      activity {\n        ").concat(content, "\n      }\n    }\n").concat(fragments, "\n");
};
export var generateActivityQueryWithFilters = function generateActivityQueryWithFilters(product, filters, activityQueries, fragments) {
  /**
   * If we are filtering by `actors` then we can't use the `myActivity` query.
   */
  if (Array.isArray(filters.actors)) {
    // you can't view `viewed` events for other accounts
    var filteredAccountQueries = activityQueries.filter(function (query) {
      return query !== 'viewed';
    });
    return {
      query: getActivitiesQuery(product, filteredAccountQueries.map(function (query) {
        return activityQueryMap.get(query);
      }).join('\n'), fragments, 'ActivityFilter'),
      queryFilters: ACTIVITY_FILTER_COLLECTION.v3.get('activities')(filters)
    };
  } else {
    return {
      query: getActivitiesQuery(product, getMyActivitiesQuery(activityQueries.map(function (query) {
        return activityQueryMap.get(query);
      })), fragments, 'MyActivityFilter'),
      queryFilters: ACTIVITY_FILTER_COLLECTION.v3.get('myActivity')(filters)
    };
  }
};
export var generateGraphQLRequest = function generateGraphQLRequest(product, filters, activityQueries, fragments) {
  var _filters$limit = filters.limit,
    limit = _filters$limit === void 0 ? ACTIVITIES_LIMIT : _filters$limit,
    restFilters = _objectWithoutProperties(filters, _excluded);
  var _generateActivityQuer = generateActivityQueryWithFilters(product, restFilters, activityQueries, fragments),
    query = _generateActivityQuer.query,
    queryFilters = _generateActivityQuer.queryFilters;
  return {
    operationName: getOperationName(product),
    query: query,
    variables: {
      first: limit,
      filter: queryFilters
    }
  };
};